import styles from '../_performance-reporting.module.scss';
import { Grid, GridCellProps, GridColumn as Column, GridItemChangeEvent } from '@progress/kendo-react-grid';
import TabPanel from '../../../Shared/TabPanel/TabPanel';
import { sort, groupBy, sum, includes } from 'ramda';
import {
  submitTabPerformanceReport,
  updatePerformanceReport  
} from '../../../../Store/PerformanceReport/actions';
import { Button} from '@mui/material';
import { IPerformanceReportItemValue } from '../../../../Models/PerformanceReportItemValue';
import { ShowModifiedDateWarning } from '../../../../Helpers/Utilities';
import { DpgReportStatuses } from '../../../../Helpers/Constants';
import ConfirmationDialog from '../../../Dialogs/ConfirmationDialog/ConfirmationDialog';
import { IPerformanceCategory } from '../../../../Models/PerformanceCategory';
import EditorCell from '../EditCell';
import { ChangeCell, MoneyCell, NameCell, NotesCell, SortOrderCell, 
  SummaryMoneyCellCurrent, SummaryMoneyCellPrevious, SummaryMoneyCellPreviousPeriod 
} from '../GridCellComponents/GridCellComponents';
import { IPerformanceReport } from '../../../../Models/PerformanceReport';
import { IPerformanceItem, SummationType } from '../../../../Models/PerformanceItem';
import { useDialog } from "../../../Providers/DialogProvider";
import { useDispatch } from 'react-redux';
export interface PerformanceCategoryTabPanelProps {
    performanceReport: IPerformanceReport;
    performanceCategory: IPerformanceCategory;
    tabValue: string;
  activeTabValue: string;
    performanceItems: IPerformanceItem[];
    completedCategories: string[];
    reportSubmitted: boolean;
    tabIsComplete: boolean;
    tabCategoryId: string;
}
export default function PeformanceCategoryTabPanel(props: PerformanceCategoryTabPanelProps) {    
  const { performanceReport, performanceCategory, tabValue, activeTabValue, performanceItems, completedCategories, reportSubmitted, tabIsComplete, tabCategoryId } = props;
    const [openDialog, closeDialog] = useDialog();
    const dispatch = useDispatch();
    const buttonBackground = tabIsComplete ? '#d95137' : '#00a139';
    const bySummaryGroupName = groupBy((perfornamceReportItemValue: IPerformanceReportItemValue) => {
      return perfornamceReportItemValue.summaryGroupName;
    });
    const isPerformanceItemInCategory = (performanceItemId: string, categoryId: string): boolean => {
        return performanceItems.find(pi => pi.id === performanceItemId && pi.performanceItemCategoryId === categoryId) !== undefined;
      };
    const performanceReportItemValues = sort((left: IPerformanceReportItemValue, right: IPerformanceReportItemValue) => left.sortOrder < right.sortOrder ? -1 : 1, 
      performanceReport.performanceReportItemValues.filter(pi => isPerformanceItemInCategory(pi.performanceItemId, performanceCategory.id!)));

    const summaryGroups = bySummaryGroupName(performanceReportItemValues.filter((pi: IPerformanceReportItemValue) => pi.summaryGroupName !== null && pi.summaryGroupName !== undefined));
    const summations = Object.keys(summaryGroups).map(sgKey => {
      const performanceItem = performanceItems.find(epi => epi.id === summaryGroups[sgKey]!.map((pi: IPerformanceReportItemValue) => pi.performanceItemId)[0]);
      const thisReportValue = sum(summaryGroups[sgKey]!.map((pi: IPerformanceReportItemValue) => {
        const itemPerformanceItem = performanceItems.find(pItem => pItem.id === pi.performanceItemId);
        return itemPerformanceItem?.summationType === SummationType.Subtract ? (-1 * (pi.value as number)) : pi.value as number
      }));
      const lastReportValue = sum(summaryGroups[sgKey]!.map((pi: IPerformanceReportItemValue) => {
        const itemPerformanceItem = performanceItems.find(pItem => pItem.id === pi.performanceItemId);
        return itemPerformanceItem?.summationType === SummationType.Subtract ? (-1 * (pi.previousPeriodValue as number)) : pi.previousPeriodValue as number;
      }));
      return {
        summaryItem: sgKey,
        thisReport: thisReportValue,
        lastReport: lastReportValue,
        valueType: performanceItem?.valueType,
        change: thisReportValue && lastReportValue
          ? ((thisReportValue - lastReportValue) / lastReportValue) * 100
          : 0
      }
    });
  return <TabPanel value={activeTabValue} index={tabValue} >
      <div className={styles.gridContainer}>
        <div className={styles.reportItemsGrid}>
          <Grid data={performanceReportItemValues
            .map((pi: IPerformanceReportItemValue) => {
              const performanceItem = performanceItems.find(epi => epi.id === pi.performanceItemId);
              return {
                ...pi,
                name: performanceItem?.name ?? "Missing",
                description: performanceItem?.description ?? "",
                inEdit: !includes(performanceCategory.id, completedCategories) && !reportSubmitted,
                valueType: performanceItem?.valueType,
                summationType: performanceItem?.summationType,
                change: pi.value && pi.previousPeriodValue
                  ? (((pi.value as number) - (pi.previousPeriodValue as number)) / (pi.previousPeriodValue as number)) * 100
                  : 0
              }
            })
          }

            // disabled={includes(key.toString(), completedCategories)}

            onItemChange={(event: GridItemChangeEvent) => {
              // debounceReportUpdate(event.dataItem.id, event.field as string, event.value);
              dispatch(updatePerformanceReport(event.dataItem.id, event.field as string, event.value));
            }}
            editField="inEdit" >
            <Column field="SortOrder" width="75px" title="#" editable={true} cell={(props: GridCellProps) => <SortOrderCell {...props} />} />
            <Column field="name" width="350px" title="Name" editable={true} cell={(props: GridCellProps) => <NameCell {...props} />} />
            <Column className={styles.alignRight} field="sourceValue" width="165px" title="Per DMS" editable={false} cell={(props: GridCellProps) => <MoneyCell {...props} />} />
            <Column field="value" width="200px" title="This Report" editable={!includes(performanceCategory.id, completedCategories) && !reportSubmitted} cell={EditorCell} />
            <Column field="previousPeriodValue" width="150px" title="Last Report" editable={false} cell={SummaryMoneyCellPreviousPeriod} />
            <Column field="change" width="150px" title="Change" editable={false} cell={ChangeCell} />
            <Column field="notes" title="Add a Note" editable={!includes(performanceCategory.id, completedCategories) && !reportSubmitted} editor="text" cell={NotesCell} />
          </Grid>
        </div>
        <div className={styles.summary}>
          <div className={styles.summaryGrid}>
            <Grid data={summations} style={{ width: '100%' }}>
              <Column field="summaryItem" width="590px" title="&nbsp;" editable={false} />
              <Column field="thisReport" width="200px" title="This Report" editable={false} cell={SummaryMoneyCellCurrent} />
              <Column field="lastReport" width="150px" title="Last Report" editable={false} cell={SummaryMoneyCellPrevious} />
              <Column field="change" width="150px" title="Change" editable={false} cell={ChangeCell} />
            </Grid>
          </div>
          <div className={styles.summaryActions}>
            <Button className={styles.submitButton} variant='contained'
              style={{ background: buttonBackground, borderRadius: '0px', height: '60px', width: '200px', marginRight: '10px', visibility: reportSubmitted ? "hidden" : "visible" }}
              onClick={async () => {
                const performanceTextPerformanceItemIds = performanceItems.filter(pi => pi.valueType === 5).map(pi => pi.id);
                if (await ShowModifiedDateWarning(performanceReport)) {
                  openDialog({
                    fullScreen: false,
                    children: (
                      <ConfirmationDialog
                        closeDialog={closeDialog} //cancel
                        prompt="The application has been saved by someone else since you opened it. Continue saving anyway?"
                        title="Save and Overwrite?"
                        accept={() => {
                          closeDialog();
                          if (tabIsComplete) {
                            dispatch(submitTabPerformanceReport(performanceReport, tabCategoryId, DpgReportStatuses.inProgress));
                          } else {
                            dispatch(submitTabPerformanceReport(performanceReport, tabCategoryId, DpgReportStatuses.submitted));
                          }
                        }}
                      />
                    ),
                  });
                } else {
                  if (tabIsComplete) {
                    dispatch(submitTabPerformanceReport(performanceReport, tabCategoryId, DpgReportStatuses.inProgress));
                  } else {
                    dispatch(submitTabPerformanceReport(performanceReport, tabCategoryId, DpgReportStatuses.submitted));
                  }
                }
              }}
            >
              {tabIsComplete ? "Unlock Category" : "Mark Category Complete"}
            </Button>
          </div>
        </div>
      </div>
    </TabPanel>    
  }